import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  getDateFromatted(timestamp: number): string {
    let dateFormatted = '';

    if (timestamp > 0) {
      const date: Date = this.getDateFromTimestamp(timestamp);

      const year = date.getUTCFullYear();
      const monthNumber = date.getUTCMonth() + 1;
      const month = monthNumber > 9 ? monthNumber : '0' + monthNumber;
      const day = date.getUTCDate() > 9 ? date.getUTCDate() : '0' + date.getUTCDate();
      const hour = date.getUTCHours() > 9 ? date.getUTCHours() : '0' + date.getUTCHours();
      const min = date.getUTCMinutes() > 9 ? date.getUTCMinutes() : '0' + date.getUTCMinutes();
      const sec = date.getUTCSeconds() > 9 ? date.getUTCSeconds() : '0' + date.getUTCSeconds();
      dateFormatted = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec + ' (UTC)' ;
    }

    return dateFormatted;
  }

  getDateFromTimestamp(timestamp: number): Date {
    return new Date(timestamp * 1000);
  }

  getTimestampUtc(): number {
    return new Date().getTime();
  }
}
